<template>
    <v-form name="set-classify-form">
        <div class="grid"
             style="margin-top:5px">
            <FormInputNumber fieldName="budget_assumed"
                             label="Budget assumed"
                             size="4"
                             validation="required"
                             :allowEmpty="true"
                             :default="null"
                             v-model:field="budget_assumed" />
            <FormInputNumber fieldName="sales_potential"
                             label="Sales potential"
                             size="4"
                             validation="required"
                             :allowEmpty="true"
                             :default="null"
                             v-model:field="sales_potential" />
            <FormInputNumber fieldName="conversion_chance"
                             label="Conversion chance (%)"
                             size="4"
                             suffix="%"
                             validation="required"
                             :allowEmpty="true"
                             :min="0"
                             :max="100"
                             :step="5"
                             :showButtons="true"
                             :default="null"
                             v-model:field="conversion_chance" />
        </div>

        <div class="grid"
             style="margin-top:20px">
            <Button @click.stop="setClassify"
                    :class="buttonClass('green')">
                <template class="flex items-center gap-1"><i class="fa-solid fa-dolly"></i><span>{{ __('Classify') }}</span></template>
            </Button>

            <Button @click="cancel"
                    :class="buttonClass('gray')">
                <template class="flex items-center gap-1"><i class="fa-regular fa-trash-can"></i><span>{{ __('Cancel') }}</span></template>
            </Button>
        </div>
    </v-form>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Button from 'primevue/button';
import FormInputNumber from '@crud/FormInputNumber.vue'
import { __, getFromRoute, screenMessage, buttonClass } from '@pages/Helper/utils.js'
import { validation } from '@pages/Helper/crud_utils.js'

// -----------------------------------------------------
const props = defineProps({
    leadData: Object,
    formProps: Object,
})

const isSetClassifyModalOpen = defineModel('isSetClassifyModalOpen')
const budget_assumed = ref('')
const sales_potential = ref('')
const conversion_chance = ref('')

// -----------------------------------------------------

onMounted(() => {
    if (props.leadData) {
        budget_assumed.value = props.leadData.budget_assumed
        sales_potential.value = props.leadData.sales_potential
        conversion_chance.value = props.leadData.conversion_chance
    }
})

// -----------------------------------------------------

const cancel = () => {
    isSetClassifyModalOpen.value = false
}
// -----------------------------------------------------

const setClassify = async () => {
    const formData = {
        'id': props.leadData.id,
        'status_symbol': 'SYM_CLASSIFIED',
        'budget_assumed': budget_assumed.value,
        'sales_potential': sales_potential.value,
        'conversion_chance': conversion_chance.value,
    }

    if (validation(formData, 'set-classify-form')) {
        const response = await getFromRoute('lead-status-set', formData, 'post');
        screenMessage({ ...response })

        isSetClassifyModalOpen.value = false
        props.formProps.closeModal()
        props.formProps.getLazyData()
    }
}
// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
